<template>
  <v-container fluid class="pa-0">
    <v-layout column>
      <v-flex xs12>
        <v-toolbar flat>
          <v-toolbar-title>Utilizatori</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical>
          </v-divider>
          <v-btn icon @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cautare"
            single-line
            hide-details>
          </v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 style="position: relative; flex-basis: auto">
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          :loading="loading"
          :search="search"
          item-key="_id"
          :expand="expand">
          <template v-slot:items="props">
            <td style="white-space: nowrap">
              <v-btn icon small class="ma-0" @click="_cbRemoveUser(props.item._id)">
                <v-icon small color="error lighten-2">mdi-delete</v-icon>
              </v-btn>
              <v-btn icon small class="ma-0" @click="_cbEditUser(props.item)">
                <v-icon small color="accent lighten-2">mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small class="ma-0" @click="_cbExpand(props)">
                <v-icon small color="accent lighten-2">mdi-unfold-more-horizontal</v-icon>
              </v-btn>
            </td>
            <td>{{ props.item.username }}</td>
            <td>{{ props.item.email }}</td>
            <td><v-icon small :color="props.item.admin ? 'green' : 'red lighten-4'">{{ props.item.admin ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
            <td><v-icon small :color="props.item.user ? 'green' : 'red lighten-4'">{{ props.item.user ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
            <td><v-icon small :color="props.item.excel ? 'green' : 'red lighten-4'">{{ props.item.excel ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
            <td><v-icon small :color="props.item.pdf ? 'green' : 'red lighten-4'">{{ props.item.pdf ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
            <td><v-icon small :color="props.item.dummy ? 'green' : 'red lighten-4'">{{ props.item.dummy ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
            <td style="text-align: center">
              <v-chip small :color="props.item.color" v-if="props.item.color && props.item.color.length"></v-chip>
              <template v-else>
                -
              </template>
            </td>
            <td style="white-space: nowrap;">
              <img :src="`${url}/svg/${props.item.username}-done.png?${Date.now()}`" width="12" class="mr-2">
              <img :src="`${url}/svg/${props.item.username}-edited.png?${Date.now()}`" width="12" class="mr-2">
              <img :src="`${url}/svg/${props.item.username}-repozare.png?${Date.now()}`" width="12" class="mr-2">
              <img :src="`${url}/svg/${props.item.username}-logo.png?${Date.now()}`" width="24">
            </td>
            <td>
              <template v-if="props.item.lastMapCenter">
                <div class="d-flex">
                  <div class="d-inline-flex" style="flex-direction: column; justify-content: center;">
                    <span style="flex: 0 0 auto">lat: {{ props.item.lastMapCenter.lat }}</span>
                    <span style="flex: 0 0 auto">lng: {{ props.item.lastMapCenter.lng }}</span>
                  </div>
                  <v-btn icon @click="showOnMap(props.item.lastMapCenter, 1, props.item)">
                    <v-icon color="primary">
                      mdi-map-marker
                    </v-icon>
                  </v-btn>
                </div>
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>
              <template v-if="props.item.currentPosition">
                <div class="d-flex">
                  <div class="d-inline-flex" style="flex-direction: column; justify-content: center;">
                    <span style="flex: 0 0 auto">lat: {{ props.item.currentPosition.lat }}</span>
                    <span style="flex: 0 0 auto">lng: {{ props.item.currentPosition.lng }}</span>
                  </div>
                  <v-btn icon @click="showOnMap(props.item.currentPosition, 2, props.item)">
                    <v-icon color="primary">
                      mdi-map-marker
                    </v-icon>
                  </v-btn>
                </div>
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>{{ props.item.zoom }}</td>
            <td>{{ props.item.mapType }}</td>
            <td>{{ props.item.zoomDetailsPage }}</td>
            <td>{{ props.item.mapTypeDetailsPage }}</td>
            <td>{{ new Date(props.item.createdAt).toLocaleString('ro-RO') }}</td>
            <td>{{ new Date(props.item.updatedAt).toLocaleString('ro-RO') }}</td>
          </template>
          <template v-slot:expand="props">
            <v-card flat style="width: 75vw">
              <v-card-text>
                <v-progress-linear color="primary" :indeterminate="true" v-if="loadingExpanded" height="4"></v-progress-linear>
                <template v-else>
                  <v-btn @click="_cbRequestPoze(props.item._id)" class="ma-4">
                    Request nou pt lista poze aflate in asteptare
                  </v-btn>
                  <v-alert type="info" class="ml-4" :value="true" outline>
                    Daca user-ul nu este live, doar ultimul request primeste raspuns cand user-ul intra in app.+
                    La fel si pt mai multe request-uri trimise in cascada.
                  </v-alert>

                  <br>

                  <v-container fluid grid-list-md>
                    <v-data-iterator
                      :items="expandedData.data"
                      :rows-per-page-items="rowsPerPage"
                      :pagination.sync="expandedPagination"
                      :total-items="expandedDataTotal"
                      content-tag="div"
                      content-class="d-layout"
                      row
                      wrap>
                      <template v-slot:item="props">
                        <v-flex class="ma-2">
                          <v-card>
                            <v-card-title>
                              <h4 style="display: flex; flex-grow: 1; white-space: nowrap">
                                <div>
                                  <v-icon small>mdi-calendar-question</v-icon>
                                  {{ new Date(props.item.createdAt).toLocaleString('ro-RO') }}
                                  <v-divider></v-divider>
                                  <v-icon small>mdi-calendar-account</v-icon>
                                  {{ props.item.response ? new Date(props.item.updatedAt).toLocaleString('ro-RO') : '-' }}
                                </div>
                                <v-spacer></v-spacer>

                                <v-btn small icon @click="deleteRequest(props.item)">
                                  <v-icon small color="error">
                                    mdi-close
                                  </v-icon>
                                </v-btn>
                              </h4>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-list dense class="lighten-4" :class="{ 'green': props.item.response, 'red': !props.item.response }">
                              <v-list-tile @click="showFilesQueue(props.item)">
                                <v-list-tile-content>Poze:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ props.item.response ? props.item.response.files.length : 0 }}</v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                          </v-card>
                        </v-flex>
                      </template>
                    </v-data-iterator>
                  </v-container>
                </template>
              </v-card-text>
            </v-card>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-btn
      @click.stop="_cbAddUser"
      absolute
      dark
      fab
      bottom
      right
      color="primary"
      style="bottom: 10px">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="addUserDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">Adaugare user</v-card-title>
        <v-card-text>
          <v-form v-model="addUserValid" ref="addUserForm">
            <v-text-field
              v-model="newUser.username"
              label="Username"
              :rules="[rules.required]">
            </v-text-field>
            <v-text-field
              type="email"
              v-model="newUser.email"
              label="Email"
              :rules="[rules.required, rules.email, unique]">
            </v-text-field>
            <v-text-field
              v-model="newUser.password"
              label="Password"
              :type="pwdVis ? 'text' : 'password'"
              @click:append="_cbTogglePwdVis"
              :append-icon="pwdVis ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min8]">
            </v-text-field>
            <v-text-field
              class="color-input"
              type="color"
              v-model="newUser.color"
              label="Culoare"
              :rules="[rules.required]">
            </v-text-field>
            <v-radio-group v-model="newUser.type" row>
              <v-radio label="Admin" value="admin"></v-radio>
              <v-radio label="User" value="user"></v-radio>
              <v-radio label="Vizitator" value="dummy"></v-radio>
              <v-radio label="Excel" value="excel"></v-radio>
              <v-radio label="Pdf" value="pdf"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeAddUserDialog" :disabled="loading">Renunta</v-btn>
          <v-btn flat color="accent" @click="addUser" :loading="loading" :disabled="loading">Adauga user</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeUserDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">Stergere user</v-card-title>
        <v-card-text>
          <v-alert :value="true" type="warning">
            Sunteti sigur(a) ca doriti sa stergeti acest utilizator?
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeRemoveUserDialog" :disabled="loading">Renunta</v-btn>
          <v-btn flat color="accent" @click="removeUser" :loading="loading" :disabled="loading">Sterge user</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editUserDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">Modificare informatii user</v-card-title>
        <v-card-text>
          <v-form v-model="editUserValid" ref="editUserForm">
            <v-text-field
              v-model="selectedUser.username"
              label="Username"
              :rules="[rules.required]">
            </v-text-field>
            <v-text-field
              type="email"
              v-model="selectedUser.email"
              label="Email"
              :rules="[rules.required, rules.email, unique]">
            </v-text-field>
            <v-text-field
              :type="pwdVis ? 'text' : 'password'"
              @click:append="_cbTogglePwdVis"
              :append-icon="pwdVis ? 'mdi-eye' : 'mdi-eye-off'"
              v-model="selectedUser.password"
              label="Password"
              hint="Completati doar daca doriti modificarea parolei existente"
              persistent-hint
              :rules="[rules.min8]">
            </v-text-field>
            <v-text-field
              class="color-input"
              type="color"
              v-model="selectedUser.color"
              label="Culoare"
              :rules="[rules.required]">
            </v-text-field>
            <v-radio-group v-model="selectedUser.type" row>
              <v-radio label="Admin" value="admin"></v-radio>
              <v-radio label="User" value="user"></v-radio>
              <v-radio label="Vizitator" value="dummy"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeEditUserDialog" :disabled="loading">Renunta</v-btn>
          <v-btn flat color="accent" @click="editUser" :loading="loading" :disabled="loading">Modifica informatii user</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMap" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">{{ locationType === 1 ? 'Ultimul centru al hartii' : 'Ultima pozitie cunoscuta' }}</v-card-title>
        <v-card-text v-if="location" style="height: 75vh; display: flex" :style="{ 'flex-direction': $vuetify.breakpoint.mdAndDown ? 'column' : 'row' }">
          <GmapMap
            style="flex-grow: 10"
            :center="location"
            :zoom="17"
            :style="{ width: 'auto', height: $vuetify.breakpoint.mdAndDown ? 'calc(75vh - 400px)' : '100%' }"
            :options="{ styles: mapStyles }"
            ref="map">
            <GmapMarker :position="location" :icon="{
              url: locationType === 1 ? 'https://maps.google.com/mapfiles/ms/icons/green-dot.png' : `${url}/svg/${username}-logo.png?${Date.now()}`,
              scaledSize: { width: 30, height: 30 }
            }" />
          </GmapMap>
          <div style="flex-grow: 1; height: 100%; overflow-y: auto;">
            <v-data-table
              :loading="loadingLocations"
              dense
              class="elevation-0"
              :items="locations"
              :headers="[
                { text: 'lat', value: 'lat' },
                { text: 'lng', value: 'lng' },
                { text: 'acuratete', value: 'accuracy' },
                { text: 'data', value: 'createdAt' },
                { text: 'actiuni', value: 'actions' }
              ]"
              item-key="_id">
              <template slot="items" slot-scope="{ item }">
                <td>{{ item.lat }}</td>
                <td>{{ item.lng }}</td>
                <td>{{ Number(item.accuracy).toFixed(2) }}m</td>
                <td>{{ new Date(item.createdAt).toLocaleString('ro-RO') }}</td>
                <td>
                  <v-btn icon @mouseover="startHighlight(item)" @mouseout="stopHighlight">
                    <v-icon>mdi-map-marker</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>

            <v-layout style="flex-grow: 1" column pa-4>
              <v-flex xs12 class="my-2">
                <v-btn @click="panToLocations">
                  <v-icon left>mdi-image-filter-center-focus-strong-outline</v-icon>
                  Incadreaza traseul
                </v-btn>
              </v-flex>
              <v-flex xs12 class="my-2">
                <v-menu
                  v-model="dayMenu"
                  :close-on-content-click="false"
                  full-width
                  max-width="290">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      prepend-icon="mdi-calendar"
                      :value="dayFormatted"
                      label="Valori pentru ziua"
                      hide-details
                      readonly
                      v-on="on">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    :allowed-dates="allowedDates"
                    v-model="day"
                    @change="dayMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 v-if="days && days.length > 1">
                <v-slider
                  prepend-icon="mdi-calendar"
                  v-model="sliderDay"
                  :tick-labels="days.length < 5 ? days : []"
                  :max="days.length - 1"
                  step="1"
                  ticks="always"
                  tick-size="1">
                </v-slider>
              </v-flex>
              <v-flex xs12 v-if="locations.length">
                <v-slider
                  prepend-icon="mdi-map-marker"
                  v-model="sliderLocation"
                  :tick-labels="locationsLabels"
                  ticks="always"
                  thumb-label
                  :max="locations.length"
                  step="1"
                  tick-size="1">
                </v-slider>
              </v-flex>
              <v-flex xs12 class="my-2">
                <v-text-field
                  prepend-icon="mdi-signal-distance-variant"
                  v-model.number="accuracyValue"
                  hide-details
                  type="number"
                  label="Acuratete"
                  suffix="m"
                  block>
                </v-text-field>
              </v-flex>
              <v-flex xs12 class="my-2">
                <v-switch
                  prepend-icon="mdi-signal-distance-variant"
                  v-model="accuracyFilter"
                  :label="`Doar acuratete < ${accuracyValue}m`"
                  hide-details>
                </v-switch>
              </v-flex>
              <v-flex xs12 class="my-2">
                <v-switch
                  prepend-icon="mdi-label"
                  v-model="labelsVisibility"
                  label="Afiseaza etichete"
                  hide-details>
                </v-switch>
              </v-flex>
              <v-flex xs12 class="my-2">
                <v-switch
                  prepend-icon="mdi-flag"
                  v-model="flagsVisibility"
                  label="Afiseaza punctele intermediare"
                  hide-details>
                </v-switch>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeMap()">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="filesQueueDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">Fisiere in asteptare</v-card-title>
        <v-card-text style="height: 50vh; overflow: auto">
          <v-text-field
            v-model="searchQueue"
            append-icon="mdi-search"
            label="Filtreaza"
            single-line
            hide-details
            class="mb-2">
          </v-text-field>
          <v-data-table
            :headers="filesHeaders"
            :items="filesQueue"
            class="elevation-1"
            :search="searchQueue">
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-right">{{ prettyBytes(props.item.size) }}</td>
              <td class="text-xs-left">{{ props.item.tip }}</td>
              <td class="text-xs-left">{{ props.item.parent }}</td>
              <td class="text-xs-left">{{ props.item.idObiectiv }}</td>
              <td class="text-xs-right">{{ new Date(props.item.lastModified).toLocaleString('ro-RO') }}</td>
              <td class="text-xs-left">
                <v-icon>{{ props.item.uploaded ? 'mdi-check' : 'mdi-close' }}</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="filesQueueDialog = false">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import darkStyle from '@/mapstyles/dark.json'
import { gmapApi } from 'vue2-google-maps'
import SERVER_URL from '@/config'
import prettyBytes from 'pretty-bytes'
import { GoogleMapsOverlay as DeckOverlay } from '@deck.gl/google-maps'
import { GeoJsonLayer } from '@deck.gl/layers'
import debounce from 'lodash.debounce'

export default {
  name: 'users',

  data: () => ({
    pwdVis: false,
    prettyBytes,
    searchQueue: null,
    filesQueueDialog: false,
    filesQueue: [],
    filesHeaders: [
      { text: 'denumire', value: 'name' },
      { text: 'dimensiune', value: 'size' },
      { text: 'tip', value: 'tip' },
      { text: 'parinte', value: 'parent' },
      { text: 'obiectiv', value: 'idObiectiv' },
      { text: 'ultima modificare', value: 'lastModified' },
      { text: 'incarcat', value: 'uploaded' }
    ],
    expandedUserId: null,
    rowsPerPage: [10],
    expand: false,
    loadingExpanded: false,
    url: SERVER_URL,
    selectedItem: null,
    headers: [
      { text: 'actiuni', value: 'actions' },
      { text: 'username', value: 'username' },
      { text: 'email', value: 'email' },
      { text: 'admin?', value: 'admin' },
      { text: 'user?', value: 'user' },
      { text: 'excel?', value: 'excel' },
      { text: 'pdf?', value: 'pdf' },
      { text: 'vizitator?', value: 'dummy' },
      { text: 'culoare', value: 'color' },
      { text: 'pictograme', value: 'marker' },
      { text: 'ultimul centru al hartii', value: 'lastMapCenter' },
      { text: 'ultima pozitie cunoscuta', value: 'currentPosition' },
      { text: 'zoom', value: 'zoom' },
      { text: 'tip harta', value: 'mapType' },
      { text: 'zoom pagina detalii', value: 'zoomDetailsPage' },
      { text: 'tip harta pagina detalii', value: 'mapTypeDetailsPage' },
      { text: 'adaugat', value: 'createdAt' },
      { text: 'modificat', value: 'updatedAt' }
    ],
    addUserDialog: false,
    addUserValid: true,
    newUser: {
      username: null,
      email: null,
      password: null,
      type: 'user',
      color: '#bf0000'
    },
    rules: {
      required: val => !!val || 'Camp obligatoriu',
      min8: val => (typeof val === 'string' && val.length >= 8) || !val || 'Minim 8 caractere',
      email: value => {
        /* eslint-disable no-useless-escape */
        const re = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')
        return re.test(value) || 'Nu prea arata ca o adresa de email valida...'
      }
    },
    search: null,
    removeUserDialog: false,
    editUserDialog: false,
    selectedUser: {
      _id: null,
      username: null,
      email: null,
      password: null,
      type: null,
      color: null
    },
    editUserValid: true,
    showMap: false,
    location: null,
    locationType: null,

    locations: [],

    username: null,
    userId: null,

    accuracyFilter: false,
    labelsVisibility: false,
    flagsVisibility: false,
    accuracyValue: 10,
    loadingLocations: false,

    dayMenu: false,
    day: new Date().toISOString().substring(0, 10),
    days: null,

    highlight: false,
    sliderLocation: null
  }),

  watch: {
    async accuracyFilter (v) {
      await this.grabLocations()
      // this.clearWebglMap()
      this.drawOnMap()
    },
    async accuracyValue (v) {
      await this.grabLocations()
      // this.clearWebglMap()
      this.drawOnMap()
    },
    async day (v) {
      // this.clearWebglMap()
      await this.grabLocations()
      this.highlight = false
      this.sliderLocation = null
      this.drawOnMap()
    },
    async labelsVisibility (v) {
      // this.clearWebglMap()
      this.drawOnMap()
    },
    async flagsVisibility (v) {
      // this.clearWebglMap()
      this.drawOnMap()
    },
    sliderLocation (v) {
      this.highlight = !v ? false : this.locations[v - 1]
      // this.clearWebglMap()
      this.drawOnMap()
    }
  },

  computed: {
    dayFormatted () {
      return new Date(this.day).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
    },
    mapStyles () {
      return this.light ? [] : darkStyle
    },
    light () {
      return this.$store.getters.light
    },
    loading () {
      return this.$store.getters.loading
    },
    items () {
      return this.$store.getters.users
    },
    google: gmapApi,
    expandedData () {
      return this.$store.getters.adminRequestsData
    },
    expandedDataTotal () {
      return this.$store.getters.expandedDataTotal
    },
    expandedPagination: {
      get () {
        return this.$store.getters.expandedPagination
      },
      async set (value) {
        if (this.expandedPagination.page !== value.page) {
          this.loadingExpanded = true
          this.$store.commit('setExpandedPagination', value)
          await this.$store.dispatch('fetchAdminRequests', { _id: this.expandedUserId })
          this.loadingExpanded = false
        }
      }
    },
    sliderDay: {
      get () {
        if (this.days && this.days.length) {
          const dayIndex = this.days.findIndex(day => day === this.day)

          if (dayIndex === -1) return null

          return dayIndex
        } else {
          return null
        }
      },
      set (v) {
        this.day = this.days[v]
      }
    },
    locationsLabels () {
      let labels = []
      if (this.locations.length < 10) {
        labels = this.locations.map((location, index) => {
          const label = new Date(location.createdAt).toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
          return index === 0 ? '🚀' : index === this.locations.length - 1 ? '🏁' : label
        })
      } else {
        labels = this.locations.map((location, index) => {
          return index === this.locations.length - 1 ? '🏁' : ''
        })
      }

      labels.unshift('🚫')

      return labels
    }
  },

  methods: {
    _cbTogglePwdVis () {
      this.pwdVis = !this.pwdVis
    },
    deleteRequest (item) {
      this.$store.dispatch('deleteAdminRequest', { id: item._id, user_id: item.user_id })
    },
    showFilesQueue (item) {
      if (item.response) {
        this.filesQueue = item.response.files
        this.filesQueueDialog = true
      }
    },
    _cbRequestPoze (_id) {
      this.$store.dispatch('sendAdminRequest', { _id })
    },
    _cbExpand (props) {
      props.expanded = !props.expanded
      if (props.expanded) {
        this.$store.commit('clearAdminRequestsData')
        this.loadingExpanded = true
        this.expandedUserId = props.item._id
        this.getExpandedData()
      } else {
        this.loadingExpanded = false
        this.$store.commit('clearAdminRequestsData')
        this.expandedUserId = null
        this.$set(this.expandedPagination, 'page', 1)
      }
    },
    async getExpandedData () {
      await this.$store.dispatch('fetchAdminRequests', { _id: this.expandedUserId })
      this.loadingExpanded = false
    },
    unique (val) {
      const user = this.items.find(u => u.email === val)

      if (!user) return true

      if (this.selectedUser._id) {
        return this.selectedUser._id === user._id || 'Email existent in baza de date'
      }

      return !user || 'Email existent in baza de date'
    },
    _cbAddUser () {
      this.addUserDialog = true
    },
    closeAddUserDialog () {
      this.addUserDialog = false
      this.$set(this.newUser, 'username', null)
      this.$set(this.newUser, 'email', null)
      this.$set(this.newUser, 'password', null)
      this.$set(this.newUser, 'type', 'user')
      this.$set(this.newUser, 'color', '#bf0000')
    },
    addUser () {
      const valid = this.$refs.addUserForm.validate()

      if (valid) {
        const newUser = {
          username: this.newUser.username,
          email: this.newUser.email,
          password: this.newUser.password,
          color: this.newUser.color
        }

        switch (this.newUser.type) {
          case 'user': {
            newUser.user = true
            newUser.dummy = false
            newUser.excel = false
            newUser.pdf = false
            newUser.admin = false
            break
          }
          case 'dummy': {
            newUser.user = false
            newUser.dummy = true
            newUser.excel = false
            newUser.pdf = false
            newUser.admin = false
            break
          }
          case 'admin': {
            newUser.user = false
            newUser.dummy = false
            newUser.excel = false
            newUser.admin = true
            break
          }
          case 'excel': {
            newUser.user = false
            newUser.dummy = false
            newUser.admin = false
            newUser.excel = true
            newUser.pdf = false
            break
          }
          case 'pdf': {
            newUser.user = false
            newUser.dummy = false
            newUser.admin = false
            newUser.excel = false
            newUser.pdf = true
            break
          }
        }

        this.$store.dispatch('addUser', newUser)

        this.closeAddUserDialog()
      }
    },

    _cbEditUser (user) {
      this.$set(this.selectedUser, '_id', user._id)
      this.$set(this.selectedUser, 'username', user.username)
      this.$set(this.selectedUser, 'email', user.email)
      this.$set(this.selectedUser, 'color', user.color || '#bf0000')

      if (user.admin) this.$set(this.selectedUser, 'type', 'admin')
      else if (user.user) this.$set(this.selectedUser, 'type', 'user')
      else this.$set(this.selectedUser, 'type', 'dummy')

      this.editUserDialog = true
    },
    closeEditUserDialog () {
      this.$set(this.selectedUser, '_id', null)
      this.$set(this.selectedUser, 'username', null)
      this.$set(this.selectedUser, 'email', null)
      this.$set(this.selectedUser, 'password', null)
      this.$set(this.selectedUser, 'type', null)
      this.$set(this.selectedUser, 'color', null)

      this.editUserDialog = false
    },
    editUser () {
      const valid = this.$refs.editUserForm.validate()

      if (valid) {
        const data = {
          email: this.selectedUser.email,
          username: this.selectedUser.username,
          color: this.selectedUser.color
        }

        switch (this.selectedUser.type) {
          case 'admin': {
            data.admin = true
            data.user = false
            data.dummy = false
            break
          }
          case 'user': {
            data.admin = false
            data.user = true
            data.dummy = false
            break
          }
          case 'dummy': {
            data.admin = false
            data.user = false
            data.dummy = true
            break
          }
        }

        if (this.selectedUser.password) data.password = this.selectedUser.password

        this.$store.dispatch('patchUser', { data, id: this.selectedUser._id })

        this.closeEditUserDialog()
      }
    },
    _cbRemoveUser (id) {
      this.removeUserId = id
      this.removeUserDialog = true
    },
    closeRemoveUserDialog () {
      this.removeUserId = null
      this.removeUserDialog = false
    },
    removeUser () {
      this.$store.dispatch('removeUser', this.removeUserId)
      this.closeRemoveUserDialog()
    },
    refresh () {
      this.$store.dispatch('fetchUsers')
    },

    async grabLocationDays () {
      try {
        this.loadingLocations = true
        this.days = await this.$store.dispatch('getUserLocationDays', { user_id: this.userId })

        if (this.days.length && !this.days.includes(this.day)) {
          this.day = this.days.at(-1)
        }

        this.loadingLocations = false
      } catch (e) {
        console.log(e)
      }
    },

    async grabLocations () {
      try {
        this.loadingLocations = true
        this.locations = await this.$store.dispatch('getUserLocations', { user_id: this.userId, accuracy: this.accuracyFilter, accuracyValue: this.accuracyValue, day: this.day })
        this.sliderLocation = 0
        this.loadingLocations = false
      } catch (e) {
        console.log(e)
      }
    },

    allowedDates (date) {
      if (!this.days) return false

      return this.days.includes(date)
    },

    async showOnMap (location, type, user) {
      this.location = location
      this.locationType = type
      this.showMap = true

      this.username = user.username
      this.userId = user._id

      await this.grabLocationDays()

      await this.grabLocations()

      this.drawOnMap()
    },
    closeMap () {
      this.location = null
      this.locationType = null
      this.username = null
      this.userId = null
      this.showMap = false

      this.locations = []
      this.days = null

      this.clearWebglMap()
    },

    drawOnMap: debounce(function () {
      this.clearWebglMap()
      this.$refs.map.$mapPromise.then(() => {
        let locations = this.locations

        if (locations.length) {
          const layers = []

          const data = {
            type: 'FeatureCollection',
            features: locations.map((l, i) => {
              return {
                type: 'Feature',
                properties: {
                  id: l._id,
                  date: l.createdAt,
                  index: i
                },
                geometry: {
                  type: 'Point',
                  coordinates: [l.lng, l.lat]
                }
              }
            })
          }

          // build a separate linestring between each adjacent 2 points
          for (let i = 0; i < locations.length - 1; i++) {
            const line = {
              type: 'Feature',
              properties: {
                id: 'line',
                index: i
              },
              geometry: {
                type: 'LineString',
                coordinates: [
                  [locations[i].lng, locations[i].lat],
                  [locations[i + 1].lng, locations[i + 1].lat]
                ]
              }
            }
            data.features.push(line)
          }

          layers.push(new GeoJsonLayer({
            id: 'plot',
            data,
            pointType: 'icon+text',

            // Text

            getText: f => {
              if (f.properties.id === 'line') return null
              if (this.labelsVisibility) {
                return new Date(f.properties.date).toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(', ', '\n')
              } else {
                return null
              }
            },
            getTextSize: 12,
            getTextAnchor: 'middle',
            getAlignmentBaseline: 'center',
            getTextOffset: [0, 12],
            getTextColor: () => {
              if (this.light) {
                return [0, 0, 0, 255]
              } else {
                return [255, 255, 255, 255]
              }
            },

            // Icon

            getIcon: f => {
              if (f.properties.index === 0) {
                return {
                  url: '/img/finish.png',
                  height: 128,
                  width: 128,
                  anchorY: 128,
                  anchorX: 0
                }
              } else if (f.properties.index === locations.length - 1) {
                return {
                  url: '/img/startflag.png',
                  height: 128,
                  width: 108,
                  anchorY: 128,
                  anchorX: 0
                }
              } else {
                if (this.flagsVisibility) {
                  return {
                    url: '/img/flag.png',
                    height: 100,
                    width: 100,
                    anchorY: 100,
                    anchorX: 0
                  }
                } else {
                  return {
                    url: '/img/transparent.png',
                    height: 1,
                    width: 1,
                    anchorY: 1,
                    anchorX: 0
                  }
                }
              }
            },
            getIconSize: 40,
            iconSizeMinPixels: 40,
            iconSizeMaxPixels: 80,

            // Styles

            extruded: true,
            filled: true,
            getElevation: 3,

            // pointRadiusUnits: 'meters',
            // getPointRadius: 2,
            // pointRadiusScale: 1,
            // pointRadiusMinPixels: 8,
            // pointRadiusMaxPixels: 12,
            // pointAntialiasing: true,
            // pointBillboard: false,

            getFillColor: f => {
              // alpha should be proportional to index, in the range [10, 255]
              // if index is 0, alpha is 255
              // if index is max, alpha is 10
              const max = locations.length - 1
              const alpha = 255 - (245 / max) * f.properties.index
              if (this.light) {
                return [0, 0, 0, alpha]
              } else {
                return [255, 255, 255, alpha]
              }
            },
            getLineColor: f => {
              // color should be a point in a gradient between red and green based on index
              // if index is 0, color is green
              // if index is max, color is red
              const max = locations.length - 1
              const color = Math.round((255 / max) * f.properties.index)

              // don't take light into consideration
              return [color, 255 - color, 0, 100]
              // return [color, color, color, 255]

              // light and dark scheme
              // if (this.light) {
              //   return [0, 0, 0, 100]
              // } else {
              //   return [255, 255, 255, 100]
              // }
            },
            getLineWidth: 10,
            lineWidthMinPixels: 2,
            lineWidthMaxPixels: 20,
            lineCapRounded: true,
            lineJointRounded: true
          }))

          if (this.highlight) {
            layers.push(new GeoJsonLayer({
              visible: this.highlight,
              id: 'highlight',
              data: {
                type: 'FeatureCollection',
                features: [
                  {
                    type: 'Feature',
                    properties: {
                      id: 'highlight',
                      date: this.highlight.createdAt
                    },
                    geometry: {
                      type: 'Point',
                      coordinates: [this.highlight.lng, this.highlight.lat]
                    }
                  }
                ]
              },
              pointType: 'circle+text',

              // Styles

              pointRadiusUnits: 'meters',
              getPointRadius: 40,
              pointRadiusScale: 1,
              pointRadiusMinPixels: 20,
              pointRadiusMaxPixels: 40,
              pointAntialiasing: true,
              pointBillboard: false,

              filled: true,
              getFillColor: [0, 0, 0, 0],
              // golden color
              getLineColor: [255, 215, 0, 255],
              getLineWidth: 2,
              lineWidthMinPixels: 2,
              lineWidthMaxPixels: 2,

              // Text

              getText: f => {
                if (!this.labelsVisibility) {
                  return new Date(f.properties.date).toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(', ', '\n')
                } else {
                  return null
                }
              },
              getTextSize: 12,
              getTextAnchor: 'middle',
              getAlignmentBaseline: 'center',
              getTextOffset: [0, 52],
              getTextColor: () => {
                if (this.light) {
                  return [0, 0, 0, 255]
                } else {
                  return [255, 255, 255, 255]
                }
              }
            }))
          }

          window.overlay = new DeckOverlay({ layers })

          window.overlay.setMap(this.$refs.map.$mapObject)
        }
      })
    }, 500),
    clearWebglMap () {
      if (window.overlay) {
        window.overlay.finalize()
        window.overlay = null
      }
    },

    startHighlight (item) {
      this.panMapTo(item)
      this.highlight = item
      // this.clearWebglMap()
      this.drawOnMap()
    },

    stopHighlight () {
      if (this.sliderLocation) {
        this.highlight = this.locations[this.sliderLocation - 1]
      } else {
        this.highlight = false
      }
      // this.clearWebglMap()
      this.drawOnMap()
    },

    panMapTo (item) {
      this.$refs.map.$mapPromise.then(() => {
        // pan to location
        this.$refs.map.$mapObject.panTo({
          lat: item.lat,
          lng: item.lng
        })
      })
    },

    panToLocations () {
      if (this.locations.length === 0) {
        return
      }
      this.$refs.map.$mapPromise.then(() => {
        // build google maps bounds array from locations
        const bounds = new window.google.maps.LatLngBounds()
        this.locations.forEach(location => {
          bounds.extend(new window.google.maps.LatLng(location.lat, location.lng))
        })

        // fit map to bounds
        this.$refs.map.$mapObject.fitBounds(bounds)
      })
    }
  },

  mounted () {
    this.$store.dispatch('fetchUsers')
  }
}
</script>
